import React, { useState } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import NavbarVTC from "./NavbarVTC";

import VehicleCarousel from "./VehicleCarousel";
import Testimonials from "./Testimonials";
import { faCar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ZonesMap from "./ZonesMap";
import ChauffeurSection from "./ChauffeurSection";
import Info from "./Info";
import { useNavigate } from "react-router-dom";
export default function Home() {
  const [showContact, setShowContact] = useState(false);

  const navigate = useNavigate();
  return (
    <>
      <NavbarVTC />

      {/* Hero */}
      <section className="hero-section text-center text-white">
        <Container>
          <h1 className="hero-title">
            Chauffeur VTC sur la Côte d’Azur – Confort Premium
          </h1>
          <p className="hero-subtitle">
            Ponctuel, professionnel et disponible 7j/7. WiFi, boisson et coffre
            spacieux pour vos bagages.
          </p>
          <Button
            className="btn-primary-cta m-2"
            onClick={() => navigate("/réserver")}
          >
            <FontAwesomeIcon icon={faCar} className="me-2" />
            Réserver
          </Button>
          <Button
            className="btn-secondary-cta m-2"
            onClick={() => setShowContact(true)}
          >
            Demander un devis
          </Button>
        </Container>
      </section>
      {/* Carrousel véhicules */}
      <VehicleCarousel />
      {/* Services Premium */}
      <section className="services-vehicles-section">
        <Container>
          <h2 className="svc-heading">Services Chauffeur Privé Premium</h2>

          <Row className="justify-content-center mb-4">
            <Col md={10} lg={8} className="text-center">
              <p className="svc-lead">
                Service haut de gamme sur la Côte d'Azur, adapté aux
                déplacements privés comme professionnels. Transferts aéroports,
                mise à disposition business, excursions touristiques,
                événements, mariages et solutions corporate. Chauffeur discret,
                ponctuel, véhicule premium et confort optimal.
              </p>
            </Col>
          </Row>

          {/* Liste des services */}
          <Row className="svc-services-row justify-content-center mb-5">
            <Col md={10} lg={9}>
              <ul className="svc-services-list">
                <li>Transferts Aéroport / Gare</li>
                <li>Mise à disposition courte et longue durée</li>
                <li>Déplacements business & corporate</li>
                <li>Excursions touristiques sur la Côte d’Azur</li>
                <li>Événements & cérémonies (mariages, galas, concerts)</li>
                <li>Transport premium VIP & personnalités</li>
                <li>Solutions entreprises (facturation & reporting)</li>
              </ul>
            </Col>
          </Row>

          {/* CTA */}
          <Row className="justify-content-center mt-5">
            <Col xs="auto">
              <Button
                className="btn-secondary-cta m-2"
                onClick={() => setShowContact(true)}
              >
                Demander un devis
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Zones Desservies */}
      <section className="zones-section py-5 text-center text-white">
        <Container>
          <h2 className="mb-4 zones-title">Zones Desservies</h2>
          <p className="zones-text mb-4">
            Nous couvrons l’ensemble de la Côte d’Azur : Nice, Cannes, Monaco et
            leurs environs. Transferts aéroport, gare ou excursions
            touristiques, nous assurons un service rapide et premium.
          </p>

          <div className="zones-map-wrapper mx-auto">
            <ZonesMap />
          </div>
        </Container>
      </section>

      {/* Chauffeur */}
      <ChauffeurSection />

      {/* Témoignages */}
      <Testimonials />

      {/* Pourquoi nous choisir */}
      <section className="premium-section py-5 text-center text-white bg-dark">
        <Container>
          <h2 className="mb-4">Pourquoi nous choisir</h2>
          <Row className="gy-4">
            <Col md={3}>
              <div className="premium-card p-4 rounded shadow-sm">
                <h5>Ponctualité</h5>
                <p>Arrivée à l'heure, toujours.</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="premium-card p-4 rounded shadow-sm">
                <h5>Confort</h5>
                <p>Véhicules haut de gamme et spacieux.</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="premium-card p-4 rounded shadow-sm">
                <h5>Flexibilité</h5>
                <p>Réservation simple et rapide, 7j/7.</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="premium-card p-4 rounded shadow-sm">
                <h5>Sécurité</h5>
                <p>Chauffeur expérimenté, service fiable.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA final */}
      <section className="reservation-cta py-5 text-center text-white bg-dark">
        <Container>
          <h2>Réservez votre trajet dès maintenant</h2>

          <Button
            className="btn-secondary-cta m-2"
            onClick={() => setShowContact(true)}
          >
            Contacter le chauffeur
          </Button>
        </Container>
      </section>

      {showContact && <Info closeModal={() => setShowContact(false)} />}
    </>
  );
}
